import React, { FC, Fragment } from 'react';
import { Link, TableRow, TableCell, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import ArrowUpwardIcon from '@material-ui/icons/ArrowUpward';
import ArrowDownwardIcon from '@material-ui/icons/ArrowDownward';

import { LeaderboardScoreFragment } from 'api';
import { UserAvatar } from 'components';
import { getFullName } from 'helpers';
import { generateLink } from 'Links';

interface IProps {
  row: LeaderboardScoreFragment;
}

const useStyles = makeStyles(theme => ({
  root: {
    '&:nth-child(even)': {
      background: 'transparent',
    },
  },
  firstCell: {
    color: theme.palette.grey[600],
  },
  nameCell: {
    '&:not(:first-child)': {
      color: theme.palette.text.primary,
    },
    ...theme.mixins.overflowText(100),
  },
  pointCell: {
    '&:not(:first-child)': {
      color: theme.palette.text.primary,
    },
  },
}));

const LeaderboardTableRow: FC<IProps> = ({ row }) => {
  const classes = useStyles();
  const { user_id, ranking, position_change, score, user } = row;

  function getRanking(currentRanking: LeaderboardScoreFragment['ranking']) {
    return <Typography variant="subtitle2">{currentRanking}</Typography>;
  }

  function getChange(positionChange: LeaderboardScoreFragment['position_change']) {
    if (positionChange === 0) {
      return <Fragment>&nbsp;--&nbsp;</Fragment>;
    }

    return positionChange > 0 ? (
      <ArrowUpwardIcon fontSize="small" color="secondary" />
    ) : (
      <ArrowDownwardIcon fontSize="small" color="disabled" />
    );
  }

  return (
    <TableRow key={user_id} className={classes.root}>
      <TableCell className={classes.firstCell} padding="none">
        {getRanking(ranking)}
      </TableCell>
      <TableCell padding="none">{getChange(position_change)}</TableCell>
      <TableCell padding="none">
        <UserAvatar link size={32} user={user} />
      </TableCell>
      <TableCell padding="none" className={classes.nameCell}>
        <Link title={getFullName(user)} component={generateLink(`/profile/${user.id}`)}>
          {getFullName(user)}
        </Link>
      </TableCell>
      <TableCell padding="none" align="right" className={classes.pointCell}>
        {score}
      </TableCell>
    </TableRow>
  );
};

export default LeaderboardTableRow;
